import request from '../../utils/request';

export function createLocation(params) {
  const { companyId } = params;
  return request(`/companies/${companyId}/locations`, {
    method: 'POST',
    data: params,
  });
}

export function getLocations(params) {
  return request(`/companies/locations`, {
    method: 'GET',
    params,
  });
}

export function updateLocation(params) {
  const { locationId, companyId } = params;
  return request(`/companies/${companyId}/locations/${locationId}`, {
    method: 'PATCH',
    data: params,
  });
}
